import { styled } from '@mui/material/styles';

const LayoutRoot = styled('div') ({
  display: 'flex',
  flex: '1 1 auto',
  maxWidth: '100%',
  flexDirection: 'column',
})

export const Layout = { LayoutRoot };